import { API_URL_MAIN } from '@/config';
import { axios } from '@/lib/axios';

export type I_ResetPasswordInfo = {
    login_id: string;
    email: string;
};

export type I_ResetPasswordResponse = {
    result: number,
    error_code: string,
    error_msg: string,
    invalid_param: string,
    field: string,
    message: string
};


export const resetPassword = (data: I_ResetPasswordInfo) => {
    return axios.post(`${API_URL_MAIN}/reset_password_service`, data);
};
